module.exports = __webpack_public_path__ + "static/5-ee47f27bb8a270cc6c1f3cd5e10ce93f.png";